import { useContext } from "react";
import { ContentStatusContext } from "./content-status-context";

export function useContentStatus() {
    const context = useContext(ContentStatusContext);

    if (!context) {
        throw new Error("useContentStatus must be used within a ContentStatusProvider");
    }

    return context;
}
